<div class="modal-header">
    <div>
        <h3>{{ 'CHANGE_PASSWORD.TITLE' | translate }}</h3>
        <p>{{ 'CHANGE_PASSWORD.SUBTITLE' | translate }}</p>
    </div>
    <button class="close ms-auto" (click)="dismiss()" data-testid="auth-change-password-close-btn">
        <img src="assets/img/shared/close.svg" alt="close">
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="submit()" data-testid="auth-change-password-form">
    <div class="modal-body">
        <div class="form-grid max-w-70">

            <!-- Current Password -->
            <div class="input-group">
                <label for="currentPassword">{{ 'CHANGE_PASSWORD.CURRENT_PASSWORD' | translate }} *</label>
                <div class="position-relative">
                    <input id="currentPassword" [type]="showCurrent ? 'text' : 'password'" class="input-field"
                        [class.is-invalid]="isInvalid(currentPassword)" formControlName="currentPassword" maxlength="15"
                        [placeholder]="'CHANGE_PASSWORD_EXTRA.CURRENT_PASSWORD_PLACEHOLDER' | translate"
                        data-testid="auth-change-password-current-password-input">
                    <span class="password-toggle-icon" (click)="showCurrent = !showCurrent"
                        data-testid="auth-change-password-current-password-visibility-btn">
                        <img [src]="showCurrent ? 'assets/image/eye.svg' : 'assets/image/eye-closed.svg'" alt="toggle">
                    </span>
                </div>
                @if (isInvalid(currentPassword)) {
                <div class="error-msg">{{ 'CHANGE_PASSWORD.CURRENT_PASSWORD_REQUIRED' | translate }}</div>
                }
            </div>

            <!-- New Password -->
            <div class="input-group">
                <label for="newPassword">{{ 'CHANGE_PASSWORD.NEW_PASSWORD' | translate }} *</label>
                <div class="position-relative">
                    <input id="newPassword" [type]="showNew ? 'text' : 'password'" class="input-field"
                        [class.is-invalid]="isInvalid(newPassword)" formControlName="newPassword" maxlength="15"
                        [placeholder]="'CHANGE_PASSWORD_EXTRA.NEW_PASSWORD_PLACEHOLDER' | translate"
                        data-testid="auth-change-password-new-password-input">
                    <span class="password-toggle-icon" (click)="showNew = !showNew"
                        data-testid="auth-change-password-new-password-visibility-btn">
                        <img [src]="showNew ? 'assets/image/eye.svg' : 'assets/image/eye-closed.svg'" alt="toggle">
                    </span>
                </div>
                @if (isInvalid(newPassword)) {
                @if (newPassword.errors?.['required']) {
                <div class="error-msg">{{ 'CHANGE_PASSWORD.NEW_PASSWORD_REQUIRED' | translate }}</div>
                } @else if (newPassword.errors?.['maxlength']) {
                <div class="error-msg">{{ 'CHANGE_PASSWORD.NEW_PASSWORD_MAX' | translate }}</div>
                } @else if (newPassword.errors?.['pattern']) {
                <div class="error-msg">{{ 'CHANGE_PASSWORD.NEW_PASSWORD_PATTERN' | translate }}</div>
                }
                }
            </div>

            <!-- Confirm New Password -->
            <div class="input-group">
                <label for="confirmPassword">{{ 'CHANGE_PASSWORD.CONFIRM_PASSWORD' | translate }} *</label>
                <div class="position-relative">
                    <input id="confirmPassword" [type]="showConfirm ? 'text' : 'password'" class="input-field"
                        [class.is-invalid]="isInvalid(confirmPassword) || (form.errors?.['passwordMismatch'] && confirmPassword.touched)"
                        formControlName="confirmPassword" maxlength="15"
                        [placeholder]="'CHANGE_PASSWORD_EXTRA.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
                        data-testid="auth-change-password-confirm-password-input">
                    <span class="password-toggle-icon" (click)="showConfirm = !showConfirm"
                        data-testid="auth-change-password-confirm-password-visibility-btn">
                        <img [src]="showConfirm ? 'assets/image/eye.svg' : 'assets/image/eye-closed.svg'" alt="toggle">
                    </span>
                </div>
                @if (isInvalid(confirmPassword)) {
                <div class="error-msg">{{ 'CHANGE_PASSWORD.CONFIRM_PASSWORD_REQUIRED' | translate }}</div>
                } @else if (form.errors?.['passwordMismatch'] && confirmPassword.touched) {
                <div class="error-msg">{{ 'CHANGE_PASSWORD.PASSWORDS_MISMATCH' | translate }}</div>
                }
            </div>

        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="lite-btn" (click)="dismiss()" data-testid="auth-change-password-cancel-btn">{{ 'COMMON.CANCEL' | translate }}</button>
        <button type="submit" class="primary-btn" [disabled]="isSubmitting" data-testid="auth-change-password-submit-btn">
            @if (isSubmitting) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            }
            {{ 'COMMON.SUBMIT' | translate }}
        </button>
    </div>
</form>